import { createFileRoute } from "@tanstack/react-router";
import z from "zod";
import { orpc } from "@/orpc/client";
import { AppDetail } from "@/pages/app-detail/AppDetail";
import { AppDetailPageSkeleton } from "@/pages/app-detail/AppDetailPageSkeleton";

const AppDetailSearchSchema = z.object({
	highlight: z.enum(["paymentMethod", "iap"]).optional(),
	tab: z.enum(["referral_links", "settings"]).default("referral_links"),
	partners: z.coerce.boolean().optional(),
	c: z.string().array().default([]),
	sections: z.string().array().default([]),
});

export const Route = createFileRoute("/_app/apps/$appId/")({
	validateSearch: AppDetailSearchSchema,
	loader: async ({ context: { queryClient }, params }) =>
		queryClient.ensureQueryData(
			orpc.apps.detail.queryOptions({ input: { id: params.appId } }),
		),
	head: ({ loaderData: app }) => ({
		meta: [{ title: `${app?.name ?? "Unknown"} - Biteasy` }],
	}),
	pendingComponent: AppDetailPageSkeleton,
	component: AppDetail,
});
